// extracted by mini-css-extract-plugin
export default {"800":"(min-width: 800px)","row":"oL2opNnoUm3ilifZDWu1","error":"ZQ0wqC8m7KPf3IFf5DWE"};